import fullEnUrl from "@/assets/logo/propsys-full-en.png";
import fullHuUrl from "@/assets/logo/propsys-full-hu.png";
import markUrl from "@/assets/logo/propsys-mark.png";
import wordmarkUrl from "@/assets/logo/propsys-wordmark.png";
import { logoLang } from "@/lib/brandLang";
import { cn } from "@/lib/utils";

/** propsys jel (a ház alakú „p”), a logó nélküli helyekre és a betöltés-jelzőhöz. */
export function PropsysMark({ className }: { className?: string }) {
  return <img src={markUrl} alt="" aria-hidden className={cn("h-9 w-9 object-contain", className)} />;
}

/** A propsys logó: a menüben jel + felirat; `full`: szlogennel, a felhasználó / böngésző nyelvén. */
export function PropsysLogo({ className, full, compact }: { className?: string; full?: boolean; compact?: boolean }) {
  if (compact) return <PropsysMark className={className} />;
  const src = full ? (logoLang() === "en" ? fullEnUrl : fullHuUrl) : wordmarkUrl;
  return <img src={src} alt="propsys" className={cn(full ? "h-12 w-auto" : "h-9 w-auto", "max-w-full object-contain", className)} />;
}

/** A szervezet logója, ha van; különben márkanév monogrammal; végső esetben a propsys jel. */
export function BrandLogo({ logoUrl, brandName, className, compact, full }: { logoUrl?: string | null; brandName?: string | null; className?: string; compact?: boolean; full?: boolean }) {
  if (logoUrl) return <img src={logoUrl} alt={brandName ?? ""} className={cn("h-9 w-auto max-w-[160px] object-contain", className)} />;
  if (brandName) {
    return (
      <div className={cn("flex min-w-0 items-center gap-2.5", className)}>
        <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-brand-gradient text-base font-extrabold text-white shadow-glow">
          {brandName.trim()[0]?.toUpperCase()}
        </div>
        {!compact && <span className="truncate text-lg font-extrabold tracking-tight">{brandName}</span>}
      </div>
    );
  }
  return <PropsysLogo className={className} compact={compact} full={full} />;
}
